// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"6e6797b9","703":"1f3941a7","787":"91c853f6","925":"0bf628aa"}[chunkId] + ".chunk.js";
};